import { useState } from 'react';
import { useHistory } from 'react-router';
import en from '../../../../lang/en-us';
import { SCHEMES_RESPONSE } from '../../../../redux-store/types/portfolio';
import { RootStateType } from '../../../../redux-store/reducers';
import SchemeList from '../Switch/SchemeList';
import { useSelector } from 'react-redux';
import { SwipeableDrawer } from '@material-ui/core';
import { KYCCheck } from '../../../common/KYCCheck';
import { formatAsIndianCurrency } from '../../../../utils/currency';
import FatcaCheck from '../../../common/FatcaCheck';
import { STPFlowType } from './types';
import { TRXN_TYPE_MAP } from '../utils';
import { PanSeedCheckNew } from '../../../common/PanSeedCheckNew';

const { dbCommercial } = en;

type Props = {};

const STPTo = (props: Props) => {
    const history = useHistory<STPFlowType>();
    const [fromSchemeDrawer, setFromSchemeDrawer] = useState<boolean>(false);
    const { stpFromScheme } = history.location.state || {};
    const {
        portfolios: { data: portfolioData },
    }: any = useSelector(({ portfolio }: RootStateType) => ({
        ...portfolio,
    }));

    const currentFundSchemes =
        !!portfolioData && !!stpFromScheme
            ? portfolioData
                  .find((fundData: any) => fundData.schemes[0].amc === stpFromScheme.amc)
                  ?.schemes?.filter(
                      (scheme: SCHEMES_RESPONSE) => scheme.isin !== stpFromScheme.isin,
                  ) || []
            : [];
    return (
        <div className="curved-bg switch-to">
            <KYCCheck allowRegistration={{ isin: stpFromScheme?.isin, amc: stpFromScheme?.amc }} />
            <PanSeedCheckNew
                customPayload={{
                    taxStatus: stpFromScheme?.taxStatus || '',
                    amc: stpFromScheme?.amc,
                    folio: String(stpFromScheme?.folio),
                    trxnMode: 'FT',
                    trxnType: TRXN_TYPE_MAP.stp,
                }}
                callBackFn={() => {}}
                triggerCheck={true}
            />
            <FatcaCheck rtaName={stpFromScheme?.rtaName} />
            <h2 className="heading">
                <a onClick={() => history.goBack()}>
                    <img src="/images/left-arrow-black.svg" alt="icon" />
                </a>
                {dbCommercial.stp.heading}
            </h2>
            <h4 className="switch-from-heading">{dbCommercial.switch.selectedSwitchFrom}</h4>
            <div className="switch-from">
                <h3>
                    <span>{stpFromScheme?.schemeName}</span>
                    <a className="mobile_mode" onClick={() => setFromSchemeDrawer(true)}>
                        {dbCommercial.switch.viewDetails}
                    </a>
                </h3>
                {/* <a>
                    <img src="/images/edit-icon-filled.svg" alt="icon" />
                    {dbCommercial.switch.edit}
                </a> */}
                <div className="switch-from-info desktop_mode">
                    <div className="switch-from-txt">
                        <h6>{dbCommercial.switch.folioNo}</h6>
                        <p>{stpFromScheme?.folio}</p>
                    </div>
                    <div className="switch-from-txt">
                        <h6>{dbCommercial.switch.totalBalanceUnits}</h6>
                        <p>{stpFromScheme?.availableUnits}</p>
                    </div>
                    <div className="switch-from-txt">
                        <h6>{dbCommercial.switch.currentNav}</h6>
                        <p>
                            {formatAsIndianCurrency(stpFromScheme?.nav || 0)}
                            <img src="/images/calender-icon.svg" alt="icon" />
                            <span>
                                {dbCommercial.switch.asOn}
                                <b>{stpFromScheme?.navDate}</b>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            <h4 className="stp-to-heading" style={{ marginBottom: -20 }}>
                {dbCommercial.switch.switchToInfo}
            </h4>
            <SchemeList
                existingFunds={currentFundSchemes}
                fromScheme={stpFromScheme}
                stpFlag={true}
            />
            <div className="curved-bg-content-inner-bottom">
                <div className="table-submit">
                    {/* <Button
                        className="customBtn"
                        disabled={!selectedRows.length}
                        onClick={onHandleSubmit}
                    >
                        {dashboard.ChangeDividend.buttonText}
                    </Button> */}
                </div>
            </div>
            <SwipeableDrawer
                anchor={'bottom'}
                open={fromSchemeDrawer}
                onClose={() => setFromSchemeDrawer(false)}
                onOpen={() => setFromSchemeDrawer(true)}
                className="scheme-from-drawer"
            >
                <div className="switch-from">
                    <h3>
                        <span>{stpFromScheme?.schemeName}</span>
                    </h3>
                    <div className="switch-from-info">
                        <div className="switch-from-txt">
                            <h6>{dbCommercial.switch.folioNo}</h6>
                            <p>{stpFromScheme?.folio}</p>
                        </div>
                        <div className="switch-from-txt">
                            <h6>{dbCommercial.switch.totalBalanceUnits}</h6>
                            <p>{stpFromScheme?.closingBalance}</p>
                        </div>
                        <div className="switch-from-txt">
                            <h6>{dbCommercial.switch.currentNav}</h6>
                            <p>
                                {stpFromScheme?.nav}
                                <img src="/images/calender-icon.svg" alt="icon" />
                                <span>
                                    {dbCommercial.switch.asOn}
                                    <b>{stpFromScheme?.navDate}</b>
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </SwipeableDrawer>
        </div>
    );
};

export default STPTo;
